import websocketService from '@/services/websocketService'
import store from '@/store'

export default {
  install(Vue) {
    // Conectar WebSocket cuando el usuario esté autenticado y sea staff
    const connectWebSocketIfNeeded = () => {
      const user = store.getters['auth/user']
      const isAuthenticated = store.getters['auth/isAuthenticated']
      
      if (isAuthenticated && user && user.is_staff) {
        console.log('Usuario staff detectado, conectando WebSocket...')
        websocketService.connect()
          .then(() => {
            store.dispatch('whatsapp/setConnectionStatus', 'connected')
            console.log('WebSocket conectado exitosamente')
          })
          .catch(error => {
            console.error('Error conectando WebSocket:', error)
            store.dispatch('whatsapp/setConnectionStatus', 'disconnected')
          })
      } else {
        console.log('Usuario no es staff o no está autenticado, desconectando WebSocket...')
        websocketService.disconnect()
        store.dispatch('whatsapp/setConnectionStatus', 'disconnected')
      }
    }

    // Conectar en el inicio si ya hay usuario autenticado
    connectWebSocketIfNeeded()

    // Escuchar cambios en el estado de autenticación
    store.watch(
      (state, getters) => getters['auth/isAuthenticated'],
      () => {
        setTimeout(connectWebSocketIfNeeded, 100) // Pequeño delay para asegurar que el usuario se haya cargado
      }
    )

    // Escuchar cambios en el usuario
    store.watch(
      (state, getters) => getters['auth/user'],
      () => {
        setTimeout(connectWebSocketIfNeeded, 100)
      }
    )

    // Desconectar al salir de la aplicación
    window.addEventListener('beforeunload', () => {
      websocketService.disconnect()
    })

    // Agregar WebSocket service al prototipo de Vue para fácil acceso
    Vue.prototype.$websocket = websocketService
  }
}
